<template>
  <v-card class="login-form-card ma-1">
    <v-card-title
      class="font-weight-bold pb-0"
      :class="{ 'justify-center': view === 0 }"
    >
      <v-btn
        v-show="view != 0"
        text
        icon
        color="primary"
        class="mr-3"
        @click="view = 0"
      >
        <v-icon>fas fa-arrow-left</v-icon>
      </v-btn>
      <span>{{ currentTitle }}</span>
    </v-card-title>
    <v-window
      v-model="view"
      touchless
    >
      <v-window-item :value="0">
        <v-card-text class="text-center">
          <v-btn
            class="login-btn elevation-0"
            block
            rounded
            @click="view = 1"
          >
            {{ $t("login.login") }}
          </v-btn>
          <v-btn
            class="first-btn mt-3 mb-3 elevation-0"
            block
            rounded
            @click="view = 2"
          >
            {{ $t("login.firstConnection") }}
          </v-btn>
          <a @click="view = 3">{{ $t("login.forgotPassword") }}</a>
        </v-card-text>
      </v-window-item>
      <v-window-item :value="1">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="email"
                outlined
                clearable
                hide-details
                :label="$t('login.email')"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="password"
                outlined
                clearable
                hide-details
                :label="$t('login.password')"
                type="password"
                @keyup.enter="send"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-window-item>
      <v-window-item :value="2">
        <v-card-text>
          <v-text-field
            v-model="email"
            class="mt-1"
            outlined
            clearable
            hide-details
            :label="$t('login.email')"
            @keyup.enter="send"
          />
        </v-card-text>
      </v-window-item>
      <v-window-item :value="3">
        <v-card-text>
          <v-text-field
            v-model="email"
            class="mt-1"
            outlined
            clearable
            hide-details
            :label="$t('login.email')"
            @keyup.enter="send"
          />
        </v-card-text>
      </v-window-item>
    </v-window>
    <v-card-actions v-show="view != 0">
      <v-spacer />
      <v-btn
        color="primary"
        class="mr-3 send-btn"
        large
        icon
        @click="send"
      >
        <v-icon>fas fa-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  export default {
    name: 'LoginCard',
    data () {
      return {
        password: '',
        view: 0,
      }
    },
    computed: {
      email: {
        get () {
          return this.$store.state.user.email
        },
        set (value) {
          this.$store.commit('SET_EMAIL', value)
        },
      },
      currentTitle () {
        switch (this.view) {
          case 1:
            return this.$t('login.login')
          case 2:
            return this.$t('login.firstConnection')
          case 3:
            return this.$t('login.forgotPassword')
          default:
            return this.$t('login.welcome')
        }
      },
    },
    methods: {
      send () {
        switch (this.view) {
          case 1:
            if (this.password && this.email) {
              this.$store.dispatch('login', { email: this.email, password: this.password })
            } else {
              this.showEmptyFormAlert()
            }
            break
          case 2:
            if (this.email) {
              this.$store.dispatch('sendFirstConnection')
            } else {
              this.showEmptyFormAlert()
            }
            break
          case 3:
            if (this.email) {
              this.$store.dispatch('sendForgotPassword')
            } else {
              this.showEmptyFormAlert()
            }
            break
        }
      },
      showEmptyFormAlert () {
        this.$store.dispatch('setAlert', { bool: true, type: 'warning', text: this.$t('login.fillFields') })
      },
    },
  }
</script>
<style scoped>
.login-form-card {
  -webkit-box-shadow: 0px 3px 46px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 3px 46px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 46px 0px rgba(0, 0, 0, 0.2);
}

.login-btn.theme--light {
  color: white;
  background: linear-gradient(to left, #8743FF, #63BBE9);
}

.login-btn.theme--dark {
  color: white;
  background: linear-gradient(to left, rgb(108, 23, 253), rgb(16, 138, 204));
}

.first-btn.theme--light {
  background: '#EEEEEE';
}

.send-btn {
  -webkit-box-shadow: 0px 3px 19px 0px rgba(0, 0, 0, 0.2) !important;
  -moz-box-shadow: 0px 3px 19px 0px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0px 3px 19px 0px rgba(0, 0, 0, 0.2) !important;
}
</style>
